import React from "react";
import toastr from "toastr";
import {
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Paper,
} from "@material-ui/core"
import Box from "@mui/material/Box";
import ImageUpload from "../ImageUpload";
import GenericDialog from "../Dialog/GenericDialog";
import { makeDELETERequestOnUserServiceWithQueryParameter } from "../../Api/api";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DownloadIcon from "@material-ui/icons/GetApp";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const indianStates = [
  "Andaman And Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra And Nagar Haveli",
  "Daman And Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu And Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Pondicherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Tripura",
  "Uttar Pradesh",
  "West Bengal",
  "Telangana",
  "Uttarakhand",
];

const nriIsHoldingOptions = [
  { value: "indian", label: "Indian Passport" },
  { value: "foreign", label: "Foreign Passport" },
];

const ProofOfAddressInformationGrid = (props) => {
  const isNRI = props?.accountType === "individual_non_resident";

  React.useEffect(() => {
    if (isNRI && docType !== "Passport") {
      setDocType("Passport");
    }
  }, [isNRI]);

  function getTypeValue(val) {
    if (val) {
      if (val === "passport") return "Passport";
      else if (val === "aadhar") return "Aadhar";
      else if (val === "driver_license") return "Driver License";
    } else return "Aadhar";
  }

  function getCreateCondValue(props) {
    if (props.aadharCardDetails) {
      const keys = Object.keys(props.aadharCardDetails);

      if (props.aadharCardDetails) {
        return (
          (Object.keys(props.aadharCardDetails).length === 0 &&
            props.aadharCardDetails.constructor === Object) ||
          (keys.length === 1 && keys[0] === "failed_count")
        );
      }

      return true;
    } else {
      return true;
    }
  }

  const initialState = {
    uuid: props?.aadharCardDetails?.uuid || "",
    address: props?.aadharCardDetails?.address || "",
    expiryDate: props?.aadharCardDetails?.expiry_date || new Date(),
    state: props?.aadharCardDetails?.state || "",
    districtOrCity: props?.aadharCardDetails?.district_or_city || "",
    pincode: props?.aadharCardDetails?.pincode || "",
    country: props?.userDetails?.birthCountry || "",
    address_type: props?.aadharCardDetails?.address_type || "",
    passport_type: props?.aadharCardDetails?.passport_type || "",
    kyc_doc_plaintext_password:
      props?.aadharCardDetails?.kyc_doc_plaintext_password || "",
    nri_is_holding: props?.aadharCardDetails?.nri_is_holding || "",
    proof_of_nri_document_type:
      props?.aadharCardDetails?.proof_of_nri_document_type || "",
    proof_of_nri_document_password:
      props?.aadharCardDetails?.proof_of_nri_document_password || ""
  };
  const typeValue = getTypeValue(props?.aadharCardDetails?.type);
  const [currentState, setCurrentState] = React.useState(initialState);
  const [docType, setDocType] = React.useState(typeValue);
  const proofOfAddressOptions = ["Aadhar", "Passport", "Driver License"];
  const [createCond, setCreateCond] = React.useState(getCreateCondValue(props));
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [proofOfNriFile, setProofOfNriFile] = React.useState(null);

  const handleChange = (event) => {
    event.persist();
    setCurrentState((previousValues) => ({
      ...previousValues,
      [event.target.name]: event.target.value,
    }));
  };

  const saveAadharCardDetails = (event) => {
    event.preventDefault();
    props.saveAadharCardDetails(
      event,
      currentState,
      docType
    );
  };

  const createProofOfAddress = (event) => {
    event.preventDefault();
    currentState.selectedFile = selectedFile;
    props.createProofOfAddress(event, currentState, docType);
  };

  const handleDocTypeChange = (event) => {
    event.preventDefault();
    setDocType(event.target.value);
  };

  const setFile = (event) => {
    event.preventDefault();
    setSelectedFile(event.target.files[0]);
  };

  function getValidURLBasedOnType() {
    switch (props.aadharCardDetails.type) {
      case "aadhar": {
        return "aadhar_card";
      }
      case "passport": {
        return "passport";
      }

      case "driver_license":
        return "driver_license";
    }
  }

  function deleteProofOfAddress(event) {
    event.preventDefault();
    makeDELETERequestOnUserServiceWithQueryParameter(
      `/kyc/${getValidURLBasedOnType()}/delete/${props.currentUser.uuid}/`
    )
      .then((response) => {
        if (response?.status === 204) {
          toastr.success("Deleted Proof of Address successfully!");
          setCurrentState({
            uuid: "",
            address: "",
          });
          setShowDeleteModal(!showDeleteModal);
          setCreateCond(true);
          setSelectedFile(null);
          props.nullifyProofOfAddress(event);
        }
      })
      .catch((error) => toastr.error(error));
  }

  function downloadBase64File(base64, mimeType, fileName = "document") {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    const extension = mimeType === "application/pdf"
      ? "pdf"
      : mimeType === "image/png"
        ? "png"
        : "jpg";

    link.href = url;
    link.download = `${fileName}.${extension}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  function getBase64MimeType(base64) {
    if (!base64) return "";

    if (base64.startsWith("JVBERi0")) return "application/pdf";
    if (base64.startsWith("iVBOR")) return "image/png";
    if (base64.startsWith("/9j/")) return "image/jpeg";

    return "image/jpeg";
  }

  function openBase64InNewTab(base64, mimeType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank");
  }

  function renderImageOrPDFButton() {
    const frontBase64 =
      props?.aadharCardDetails?.front_image ||
      props?.aadharCardDetails?.image;

    const backBase64 = props?.aadharCardDetails?.back_image;

    const shouldShowBack =
      backBase64 &&
      frontBase64 &&
      backBase64 !== frontBase64;

    if (!frontBase64 && !backBase64) {
      return (
        <Typography variant="body2" color="textSecondary" align="center">
          No Proof of Address uploaded yet
        </Typography>
      );
    }

    const renderDocument = (base64, title, fileName) => {
      const mimeType = getBase64MimeType(base64);
      if (mimeType === "application/pdf") {
        return (
          <Box
            width="100%"
            p={2}
            border="1px solid #e0e0e0"
            borderRadius={2}
            textAlign="center"
          >
            <Typography variant="subtitle1" gutterBottom>
              {title}
            </Typography>
            <PictureAsPdfIcon
              sx={{ fontSize: 100, color: "#d32f2f", mb: 2 }}
            />
            <Typography variant="body2" color="textSecondary" gutterBottom>
              PDF Document Uploaded
            </Typography>
            <Box mt={2} display="flex" justifyContent="center" gap={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => openBase64InNewTab(base64, mimeType)}
              >
                Open PDF
              </Button>

              <Button
                variant="outlined"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={() =>
                  downloadBase64File(base64, mimeType, fileName)
                }
              >
                Download
              </Button>
            </Box>
          </Box>
        );
      }
      return (
        <Box
          width="100%"
          p={2}
          border="1px solid #e0e0e0"
          borderRadius={2}
          textAlign="center"
        >
          <Typography variant="subtitle1" gutterBottom>
            {title}
          </Typography>
          <img
            src={`data:${mimeType};base64,${base64}`}
            alt={title}
            style={{
              maxWidth: "100%",
              maxHeight: "260px",
              objectFit: "contain",
              borderRadius: "8px",
              border: "1px solid #ddd",
            }}
          />
          <Box mt={2}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<DownloadIcon />}
              onClick={() =>
                downloadBase64File(base64, mimeType, fileName)
              }
            >
              Download
            </Button>
          </Box>
        </Box>
      );
    };

    return (
      <Box width="100%" display="flex" flexDirection="column" gap={3}>
        {/* Front Side - Always Show */}
        {frontBase64 &&
          renderDocument(
            frontBase64,
            "Front Side",
            "proof_of_address_front"
          )}

        {/* Back Side - Show Only If Different */}
        {shouldShowBack &&
          renderDocument(
            backBase64,
            "Back Side",
            "proof_of_address_back"
          )}
      </Box>
    );
  }

  function renderSelectedFilePreview() {
    if (!selectedFile) return null;

    const fileUrl = URL.createObjectURL(selectedFile);
    const isPDF = selectedFile.type === "application/pdf";

    return (
      <Box textAlign="center" width="100%">
        {isPDF ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <PictureAsPdfIcon sx={{ fontSize: 120, color: "#d32f2f", mb: 2 }} />

            <Typography variant="body2" gutterBottom>
              {selectedFile.name}
            </Typography>
          </Box>
        ) : (
          <img
            src={fileUrl}
            alt="Selected Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "320px",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        )}
      </Box>
    );
  }

  return (
    <Grid
      container
      spacing={4}
      justifyContent="center"
      alignItems="flex-start"
      style={{ padding: "20px" }}
    >
      <Grid item>
        <Box
          sx={{
            width: 420,
            minWidth: 420,
            maxWidth: 420,
            minHeight: 520,
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 3,
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            style={{ fontWeight: 600, marginBottom: "24px" }}
          >
            {!props?.aadharCardDetails ||
              Object.keys(props.aadharCardDetails).length === 0 ||
              (Object.keys(props.aadharCardDetails).length === 1 &&
                Object.keys(props.aadharCardDetails)[0] === "failed_count")
              ? "Document Preview"
              : props.aadharCardDetails.type === "passport"
                ? `${props.aadharCardDetails.passport_type === "foreign"
                  ? "Foreign Passport"
                  : "Indian Passport"
                } Preview`
                : `${props.aadharCardDetails.type
                  ?.replace(/_/g, " ")
                  .replace(/\\b\\w/g, (char) => char.toUpperCase())
                } Preview`}
          </Typography>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {createCond ? (
              !selectedFile ? (
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                    gutterBottom
                    style={{ marginBottom: "16px" }}
                  >
                    Upload a document to preview it here
                  </Typography>

                  <ImageUpload setFile={setFile} />
                </Box>
              ) : (
                renderSelectedFilePreview()
              )
            ) : (
              renderImageOrPDFButton()
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item>
        <Paper
          style={{
            width: 650,
            minWidth: 650,
            maxWidth: 650,
            padding: "24px",
            borderRadius: "12px",
          }}
        >
          <Typography variant="h5" gutterBottom style={{ fontWeight: 600 }}>
            Proof of Address
          </Typography>

          <Box>
            {createCond && (
              <Box mb={2}>
                {isNRI ? (
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Doc Type"
                    value="Passport"
                    disabled
                  />
                ) : (
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="doc-type-select-label">
                      Doc Type
                    </InputLabel>
                    <Select
                      labelId="doc-type-select-label"
                      name="docType"
                      value={docType}
                      onChange={handleDocTypeChange}
                      label="Doc Type"
                    >
                      {proofOfAddressOptions.map((proofOfAddressOption, index) => (
                        <MenuItem value={proofOfAddressOption} key={index}>
                          {proofOfAddressOption}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            )}

            <Box mb={2}>
              <TextField
                type="text"
                name="uuid"
                variant="outlined"
                fullWidth
                label="ID Proof Number"
                onChange={handleChange}
                value={currentState.uuid}
              />
            </Box>

            {["Passport", "Driver License"].includes(docType) && (
              <Box mb={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    margin="none"
                    id="date-picker-dialog"
                    label="Expiry Date"
                    format="dd/MM/yyyy"
                    value={currentState.expiryDate}
                    onChange={(date) => {
                      setCurrentState((prev) => ({
                        ...prev,
                        expiryDate: date,
                      }));
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Box>
            )}

            {(docType.toLocaleLowerCase() === "aadhar" ||
              docType.toLocaleLowerCase() === "driver license" ||
              docType.toLocaleLowerCase() === "passport") && (
                <>
                  <Box mb={2}>
                    <TextField
                      type="text"
                      name="districtOrCity"
                      variant="outlined"
                      fullWidth
                      label="City"
                      onChange={handleChange}
                      value={currentState.districtOrCity}
                    />
                  </Box>

                  <Box mb={2}>
                    <TextField
                      type="text"
                      name="pincode"
                      variant="outlined"
                      fullWidth
                      label="Pincode"
                      onChange={handleChange}
                      value={currentState.pincode}
                    />
                  </Box>

                  <Box mb={2}>
                    <TextField
                      type="text"
                      name="country"
                      variant="outlined"
                      fullWidth
                      label="Country"
                      onChange={handleChange}
                      value={currentState.country}
                    />
                  </Box>
                </>
              )}

            <Box mb={2}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>State</InputLabel>
                <Select
                  name="state"
                  value={currentState.state}
                  defaultValue={currentState.state}
                  onChange={handleChange}
                  label="State"
                >
                  {indianStates.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box mb={2}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Address Type</InputLabel>
                <Select
                  name="address_type"
                  value={currentState.address_type}
                  onChange={handleChange}
                  label="Address Type"
                >
                  <MenuItem value="residential">Residential</MenuItem>
                  <MenuItem value="business">Business</MenuItem>
                  <MenuItem value="residential_cum_business">
                    Residential cum Business
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {docType === "Passport" && (
              <Box mb={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>Passport Type</InputLabel>
                  <Select
                    name="passport_type"
                    value={currentState.passport_type}
                    onChange={handleChange}
                    label="Passport Type"
                  >
                    {nriIsHoldingOptions.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            <Box mb={2}>
              <TextField
                type="text"
                name="address"
                variant="outlined"
                fullWidth
                multiline
                label="Address"
                onChange={handleChange}
                value={currentState.address}
              />
            </Box>

            <Box mb={2}>
              <TextField
                type="text"
                name="kyc_doc_plaintext_password"
                variant="outlined"
                fullWidth
                label="Password - If Blank, then no password is set by client"
                onChange={handleChange}
                value={currentState.kyc_doc_plaintext_password}
              />
            </Box>

            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={
                    createCond ? createProofOfAddress : saveAadharCardDetails
                  }
                >
                  {createCond ? "Create" : "Update"}
                </Button>
              </Grid>

              {!createCond && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={(event) => {
                      event.preventDefault();
                      setShowDeleteModal(!showDeleteModal);
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </Paper>
      </Grid>

      {showDeleteModal && (
        <GenericDialog
          show={showDeleteModal}
          heading="Delete Proof Of Address"
          inputProps={
            "Are you sure you want to delete this proof of address ?"
          }
          onClose={(event) => {
            event.preventDefault();
            setShowDeleteModal(!showDeleteModal);
          }}
          handleSubmit={(event) => {
            event.preventDefault();
            deleteProofOfAddress(event);
          }}
        />
      )}
    </Grid>
  );
};

export default ProofOfAddressInformationGrid;